import { Box, Container, Typography } from "@mui/material";
import PageTitleWrapper from "@/components/PageTitleWrapper";
import TablaPrecios2, { disabledColsType, separadorType } from "@/components/Tablas/TablaPrecios2/TablaPrecios2";
import { useEffect, useState } from "react";
import { useObtenerPrecioInformesQuery } from "@/redux/api/precioApi";
import { IPrecio } from "@/redux/models";


const TablaInforme = ({ tipo, nombre, precios, separador, disabledCols, tituloExpress }: { tipo: 'capital' | 'provincia' | 'catastro' | 'otros', nombre: string, precios: IPrecio[], separador?: separadorType[], disabledCols?: disabledColsType[], tituloExpress?: string }) => {

    return (

        <Box sx={{ margin: '0 auto', maxWidth: '50rem', mb: '2rem' }}>
            <Typography variant='h4' fontWeight='bold' mb='2rem' textAlign='center'>
                {nombre}
            </Typography>
            <TablaPrecios2 tipo={tipo} precios={precios} separador={separador} disabledCols={disabledCols}
                tituloExpress={tituloExpress}
            />
        </Box>
    )

}


const PreciosMainPage = () => {
    const { data } = useObtenerPrecioInformesQuery();
    const [precios, setPrecios] = useState<IPrecio[]>([])

    useEffect(() => {
        if (data) {
            setPrecios(data)
        }
    }, [data])
    return (
        <Container maxWidth="xl">
            <PageTitleWrapper>
                <Typography component='h3' sx={{
                    margin: '0px 0px 4px',
                    fontWeight: 700,
                    fontSize: '25px',
                    lineHeight: 1.4,
                }} >
                    Precios
                </Typography>

                <Typography component='p' sx={{
                    margin: '0px 0px 16px',
                    fontSize: '16px',
                    color: 'red',
                    lineHeight: 1.4,
                }} >
                    ESTOS VALORES SON EXCLUSIVOS PARA INMOBILIARIAS, ESTUDIOS JURÍDICOS Y PROFESIONALES DEL RUBRO. EL ESTUDIO DE DOCUMENTACIÓN PARA PARTICULARES IMPLICA OTROS COSTOS. CONSULTE.                </Typography>
            </PageTitleWrapper>

            <Box component='section' >
                <TablaInforme nombre="Informes de Capital" tipo='capital' precios={precios}
                    disabledCols={['provincia', 'capital', 'plazoUnico']}
                />
                <TablaInforme nombre="Informes de Provincia" tipo='provincia' precios={precios}
                    disabledCols={['provincia', 'certificada', 'capital']}
                    tituloExpress='En el día'
                />
                <TablaInforme nombre="Informes de Catastro" tipo='catastro' precios={precios}
                    disabledCols={['provincia', 'certificada', 'capital', 'simple', 'urgente', 'express']}
                    separador={[
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                CAPITAL
                            </Typography>,
                            pos: 0
                        },
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                PROVINCIA
                            </Typography>,
                            pos: 7
                        }
                    ]}
                />
                <TablaInforme nombre='Otros Informes' tipo='otros' precios={precios}
                    disabledCols={['certificada', 'express', 'simple', 'urgente']}
                    separador={[
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                AUTOMOTOR
                            </Typography>,
                            pos: 0
                        },
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                PARTIDAS
                            </Typography>,
                            pos: 4
                        },
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                ABOGADOS
                            </Typography>,
                            pos: 8
                        },
                        {
                            Componente: () => <Typography variant='h6' fontWeight='bold' textAlign='left' paddingLeft='2rem' margin='0.5rem'>
                                INFORMES DEL INTERIOR DEL PAÍS
                            </Typography>,
                            pos: 9
                        }
                    ]}

                />


            </Box>

        </Container >
    );
}

export default PreciosMainPage;